import { fr } from '@codegouvfr/react-dsfr';
import { Button } from '@codegouvfr/react-dsfr/Button';
import Tooltip from '@codegouvfr/react-dsfr/Tooltip';
import { TYPE_DECLARATION_TEXTS } from '@common/config';
import { EtablissementCardDto, StatutDeclaration, TypeDeclaration } from '@common/services/etablissement';
import React, { ReactNode } from 'react';
import { Address } from '../Address';

export const EtablissementCard = ({ etablissement, onEdit, onDelete, bottomCardJsx }: EtablissementCardProps) => {
  const contents = [
    { title: 'Adresse', text: <Address place={etablissement} /> },
    { title: 'SIRET', text: etablissement.siret },
    { title: 'Effectif', text: etablissement.effectifApprenti },
    { title: 'Déclaration', text: TYPE_DECLARATION_TEXTS[etablissement.typeDeclaration] },
  ];

  const isDeleteBlockedByDeclaration =
    ([StatutDeclaration.DEPOSEE, StatutDeclaration.PARTIELLE] as StatutDeclaration[]).includes(etablissement.statutDeclaration);

  const canShowDelete = !etablissement.principal && !!onDelete;

  return (
    <div className={'fr-card w-full'}>
      <div className={'m-6 flex flex-col gap-4'}>
        <div className={'flex flex-row'}>
          <div className={'flex justify-between w-full'}>
            <div>
              <h6 style={{ marginBottom: '12px' }}>{etablissement.denominationUsuelle}</h6>

              {(etablissement.declarant) && (
                <div>
                  {(etablissement.principal) && (
                    <i className={`${fr.cx('fr-icon-home-4-fill')} text-(--text-label-blue-france)`} />
                  )}
                  {(etablissement.typeDeclaration === TypeDeclaration.CONSOLIDEE) && (
                    <span className={'ml-3 text-sm text-[#0063CB]'}>Établissement principal déclarant</span>
                  )}
                  {(etablissement.typeDeclaration === TypeDeclaration.INDIVIDUELLE) && (
                    <span className={'text-sm text-[#0063CB]'}>Établissement déclarant</span>
                  )}
                </div>
              )}
            </div>

            <div className={'flex flex-row gap-5'}>
              {canShowDelete && !isDeleteBlockedByDeclaration && (
                <Button
                  iconId={'fr-icon-delete-fill'}
                  style={{ color: '#E1000F', borderColor: '#E1000F', boxShadow: 'none' }}
                  priority={'secondary'}
                  onClick={() => onDelete?.(etablissement.id, etablissement.denominationUsuelle)}
                />
              )}

              {canShowDelete && isDeleteBlockedByDeclaration && (
                <Tooltip title="Il y a une déclaration sur cet établissement." kind="hover">
                  <span style={{ display: 'inline-block' }}>
                    <Button
                      iconId={'fr-icon-delete-fill'}
                      priority={'secondary'}
                      disabled
                    />
                  </span>
                </Tooltip>
              )}

              {(onEdit) && (
                <Button
                  iconId={'fr-icon-edit-fill'}
                  priority={'secondary'}
                  onClick={() => onEdit?.(etablissement.id)}
                />
              )}
            </div>
          </div>
        </div>

        <div className={'mt-4 grid grid-cols-4 gap-4'}>
          {contents.map(({ title, text }, index) => (
            <div key={index} className={'flex flex-col max-w-[300px]'}>
              <span className={'text-(--text-label-blue-france)'}>{title}</span>
              <span className={'text-(--text-title-grey)'}>{text}</span>
            </div>
          ))}
        </div>

        {bottomCardJsx}
      </div>
    </div>
  );
};

interface EtablissementCardProps {
  etablissement: EtablissementCardDto;
  onEdit?: (etablissementId: number) => void;
  onDelete?: (etablissementId: number, denominationUsuelle: string) => void;
  bottomCardJsx?: ReactNode;
}